import * as S from "@/containers/Project/components/styled";
import {
  isMilestoneExpanded,
  shouldBeCollapsedWhenAllSelected,
} from "@/helpers";
import { useProjectContext } from "@/providers";
import { object, string } from "prop-types";

export const MilestoneTableExpanderButton = ({ milestone, schedule }) => {
  const {
    setExpandedMilestone,
    setCurrentSchedule,
    milestoneListChildren: { topOnly, showOrHideChildren },
    addTopLevelMilestoneToShowOrHideChildren,
    removeTopLevelMilestoneFromShowOrHideChildren,
  } = useProjectContext();

  const setExpanded = () => {
    const { topLevelParent } = milestone;

    if (topLevelParent) {
      const milestoneExpanded = isMilestoneExpanded(
        topLevelParent,
        topOnly,
        showOrHideChildren
      );
      const shouldBeCollapsed = shouldBeCollapsedWhenAllSelected(
        topLevelParent,
        topOnly,
        showOrHideChildren
      );

      if (milestoneExpanded) {
        addTopLevelMilestoneToShowOrHideChildren(topLevelParent);
      } else if (shouldBeCollapsed) {
        removeTopLevelMilestoneFromShowOrHideChildren(topLevelParent);
      }
    }

    setExpandedMilestone(milestone.id);
    setCurrentSchedule(schedule);
  };

  return (
    <S.MilestoneExpanderBtn
      data-test-id={`expand-panel-${milestone.id}-${schedule}`}
      type={"text"}
      onClick={setExpanded}
      status={milestone.status}
    >
      {milestone.milestoneName}
    </S.MilestoneExpanderBtn>
  );
};

MilestoneTableExpanderButton.propTypes = {
  milestone: object.isRequired,
  schedule: string.isRequired,
};
